// extracted by mini-css-extract-plugin
export var editInput = "_ek-0";
export var editInputCompact = "_ek-2";
export var editInputLarge = "_ek-1";
export var editInputSmall = "_ek-3";